"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
class WebRTCProvider extends DataProvider_1.default {
    get fragments() {
        return {
            WebRTCConnection: () => `
      ... on WebRTCConnection {
        producerUrl
        consumerUrl
        userKey
        opponentKey
      }`,
        };
    }
}
exports.WebRTCProvider = WebRTCProvider;
//# sourceMappingURL=WebRTCProvider.js.map